export default __webpack_public_path__ + "static/media/img1.63e499c1.gif";